import { useLanguage } from '../../context/LanguageContext';

export function StatusBadge({ status, type = 'transfer' }) {
  const { t } = useLanguage();

  const configs = {
    transfer: {
      pending: { label: t('status_pending'), className: 'bg-yellow-500/15 text-yellow-700 border-yellow-500/20' },
      processing: { label: t('status_processing'), className: 'bg-blue-500/15 text-blue-700 border-blue-500/20' },
      completed: { label: t('status_completed'), className: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/20' },
      failed: { label: t('status_failed'), className: 'bg-red-500/15 text-red-700 border-red-500/20' },
      cancelled: { label: t('status_cancelled'), className: 'bg-gray-500/15 text-gray-700 border-gray-500/20' },
    },
    kyc: {
      pending: { label: t('status_pending'), className: 'bg-gray-500/15 text-gray-700 border-gray-500/20' },
      submitted: { label: t('submitted'), className: 'bg-blue-500/15 text-blue-700 border-blue-500/20' },
      approved: { label: t('approved'), className: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/20' },
      rejected: { label: t('rejected'), className: 'bg-red-500/15 text-red-700 border-red-500/20' },
    },
    role: {
      admin: { label: t('admin_users_role_admin'), className: 'bg-orange-500/15 text-orange-700 border-orange-500/20' },
      user: { label: t('admin_users_role_user'), className: 'bg-sky-500/15 text-sky-700 border-sky-500/20' },
    },
    account: {
      active: { label: t('status_active'), className: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/20' },
      suspended: { label: t('status_suspended'), className: 'bg-red-500/15 text-red-700 border-red-500/20' },
      restricted: { label: t('status_frozen'), className: 'bg-yellow-500/15 text-yellow-700 border-yellow-500/20' },
    },
    deposit: {
      pending: { label: t('status_pending'), className: 'bg-yellow-500/15 text-yellow-700 border-yellow-500/20' },
      confirmed: { label: t('admin_deposits_status_confirmed'), className: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/20' },
      rejected: { label: t('admin_deposits_status_rejected'), className: 'bg-red-500/15 text-red-700 border-red-500/20' },
    },
  };

  const typeConfig = configs[type] || configs.transfer;
  const config = typeConfig[status] || typeConfig[Object.keys(typeConfig)[0]];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap ${config.className}`} data-testid={`badge-${type}-${status}`}>
      {config.label}
    </span>
  );
}
